import { Icon } from "@iconify/react";

const STATUS_STYLES = {
  pending: "bg-yellow-500 text-white",
  confirmed: "bg-[#DCFCE7] border border-[#B9F8CF] text-[#008236]",
  in_progress: "bg-blue-500 text-white",
  completed: "bg-[#E0E7FF] border border-[#C7D2FE] text-[#4338CA]",
  cancelled: "bg-red-500 text-white",
  no_show: "bg-gray-400 text-white",
  // Legacy statuses (backward compat)
  new: "bg-blue-100 border border-blue-300 text-blue-800",
  request: "bg-blue-100 border border-blue-300 text-blue-800",
  declined: "bg-red-100 border border-red-300 text-red-800",
};

const STATUS_LABELS = {
  pending: "Pending",
  confirmed: "Confirmed",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  no_show: "No Show",
  new: "New",
  request: "New",
  declined: "Declined",
};

const BookingStatusBadge = ({ status, icon }) => {
  const style = STATUS_STYLES[status] || "bg-gray-100 text-gray-600";
  const label = STATUS_LABELS[status] || status;

  return (
    <div className={`px-2 py-0.5 rounded-lg text-xs font-medium flex flex-row items-center gap-1 ${style}`}>
      {icon && <Icon icon={icon} className="w-4 h-4" />}
      <span>{label}</span>
    </div>
  );
};

export default BookingStatusBadge;
